<template>
  <div v-if="showloadding">
    <van-loading type="spinner" size="24px" class="pfa-ladding"
      >加载中...</van-loading
    >
  </div>
  <div v-else>
    <slot><div class="nodata">{{ text }}</div></slot>
  </div>
</template>
<script>
export default {
  name: "listLoadding",
  data() {
    return {
      text: "暂无数据",
    };
  },
  props: {
    showloadding: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
</style>